module.exports = __webpack_public_path__ + "static/media/background_ricofru.abbc7913.jpg";